import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { ChartOptions, scales } from 'chart.js';

@Component({
  selector: 'split-line',
  templateUrl: './split-line.component.html',
  styleUrls: ['./split-line.component.scss']
})
export class SplitLineComponent implements OnChanges, AfterViewInit {

  @ViewChild('chart') chartCanvas!: ElementRef;

  @Input() data: any = [];
  @Input() labels: Array<string> = []

  @Input() gradientColors: Array<string> = ['#FF9847', 'rgba(255, 255, 255, 0)']

  @Input() reduceLabels: boolean = false
  @Input() highlightLastLabel: boolean = false
  @Input() allowLegend: boolean = false

  basicData: any;
  basicOptions!: ChartOptions;

  rightpos: any = 0;
  leftpos: any = 0;
  display: any = "none";
  activedText: any = {};
  currentColor: string = ''
  cursorPointer: boolean = false

  constructor(private datePipe: DatePipe) { }

  ngOnChanges(): void {
    let lastLabel: number = this.setLastLabel()

    this.basicData = {
      labels: this.iterateLabels(),
      datasets: this.resolveDataSet()
    };

    this.basicOptions = {
      onHover: (event: any, elements: any) => {
        if (elements.length > 0) {
          this.cursorPointer = true 
        } else { this.cursorPointer = false}

        if (elements.length > 0) {
          this.display = 'block';
          this.leftpos = (event.x + 20) + 'px';
          this.rightpos = event.y + 'px';
          this.activedText.title = this.labels[elements[0].index];
          this.activedText.subtitle = this.basicData.datasets[elements[0].datasetIndex].data![elements[0].index]
          this.currentColor = elements[0].element.options.borderColor
        } else {
          this.display = 'none';
        }
      },
      animation: {
        duration: 2000,
      },
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        }
      },
      scales: {
        x: {
          ticks: {
            font: {
              family: 'Poppins',
              size: 13,
              weight: (c) => {
                if (c['tick']['value'] === lastLabel && this.highlightLastLabel) {
                  return 700
                } else {
                  return 400
                }
              }
            },
            padding: 10,
            color: (c) => {
              if (c['tick']['value'] === lastLabel && this.highlightLastLabel) {
                return this.data[0].gradientColors[0]
              } else {
                return '#999999' /* cor dos numeros rodape */
              }
            },
            callback: (value, index, values) => {
                return this.labels[index];
            }
          },
          grid: {
            display: false,
          }
        },
        y: {
          beginAtZero: true,
          grid: {
            color: "#F5F5F5"
          },
          ticks: {
            font: {
              family: 'Poppins',
              size: 13,
              weight: 400
            },
            padding: 20,
            color: '#999999',
            stepSize: 200,
            
            callback: function (value: any) {
              return 'R$ ' + value;
            }

          }
        },

      },
      elements: {
        point:{
          hitRadius: 5
        }
      }

    };

  }

  ngAfterViewInit(): void {
    const context = this.chartCanvas.nativeElement?.getContext('2d');
  }

  iterateData() {
    let dataArray: Array<number> = []

    this.data.forEach(
      (element: any) => {
        dataArray.push(element.data)
      }
    )

    return dataArray;
  }

  iterateLabels() {

    if (this.reduceLabels) {
      let labelsArray: Array<string> = []

      this.labels.forEach(
        (element: any, index: number) => {

          if (index % 2 == 0) {
            labelsArray.push(element)
          } else {
            labelsArray.push('')
          }

        }
      )

      return labelsArray

    } else {

      return this.labels

    }

  }

  setLastLabel() {
    let lastLabel: number = this.labels?.length - 1

    return this.reduceLabels ? lastLabel - 1 : lastLabel
  }

  resolveDataSet() {
    let dataSet: Array<any> = []
    this.data?.forEach(
      (dado: any) => {
        console.log(dado);
        dataSet.push({
          label: dado.legend,
          data: dado.data,
          fill: true,
          tension: 0,
          pointBorderColor: dado.gradientColors[0],
          pointBackgroundColor: '#fff',
          pointBorderWidth: '2',
          borderColor: dado.gradientColors[0],
          backgroundColor: (context: any) => {
            const bgColor = dado.gradientColors

            if (!context.chart.chartArea) {
              return;
            }

            const { ctx, data, chartArea: { top, bottom } } = context.chart
            const gradientBg = ctx.createLinearGradient(0, top, 0, bottom)
            gradientBg.addColorStop(0, bgColor[0])
            gradientBg.addColorStop(0.7, bgColor[1])
            return gradientBg;

          },

        })
      }
    )

    return dataSet;
  }

}
